/**
 * <TimePicker2
 *		// please describe props here
 *	/>
 *
 * @parent anybody
 * @children
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames';
import moment from 'moment';

import times from 'lodash/times';
import './TimePicker2.scss';

const DEFAULT_STATE = {
        hour: '',
        minute: '',
        ampm: '',
      }


class TimePicker2 extends React.Component {
  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(props) {
    super(props);

    this.renderHours = this.renderHours.bind(this);
    this.renderMinutes = this.renderMinutes.bind(this);
    this.onChange = this.onChange.bind(this);
    this.setMomentToStrTime = this.setMomentToStrTime.bind(this);
    if (props.value) {
      this.state = {
        ...this.setMomentToStrTime(props.value)
      }
    } else {
      this.state = { ...DEFAULT_STATE }
    }
  }

  componentWillReceiveProps({value}) {
    if (value) {
      this.setState(this.setMomentToStrTime(value));
    } else {
      this.setState({ ...DEFAULT_STATE });
    }
  }

  setMomentToStrTime(value) {
    return {
      hour: value.format('h'),
      minute: value.format('mm'),
      ampm: value.format('a')
    };
  }

  onChange(name) {
    return (e) => {
      const value = e.target.value;
      let newData = {}
      switch (name) {
        case 'hour':
          newData = {
            hour: value,
          }
          break;
        case 'minute':
          newData = {
            minute: value,
          }
          break;
        case 'ampm':
          newData = {
            ampm: value,
          }
          break;
      }

      const {
        onChange,
      } = this.props;

      this.setState({
        ...newData,
      }, ()=>{
        const { hour, minute, ampm } = this.state;

        const strValue = `${hour}:${minute} ${ampm}`;

        const momentValue = moment(strValue, 'h:mm a');

        onChange(momentValue, strValue);
      });
    }
  }

  renderHours() {
    return (
      <select value={this.state.hour} onChange={this.onChange('hour')} className='form-control'>
        <option></option>
        {times(12, (num, key)=>{
          const hour = num + 1;
          return <option value={hour} key={num}>{hour}</option>
        })}
      </select>
    )
  }

  renderMinutes() {
    const {
      minuteStep = 5,
    } = this.props;

    const numOfSteps = parseInt(60 / 5);

    return (
      <select value={this.state.minute} onChange={this.onChange('minute')} className='form-control'>
        <option></option>
        {times(numOfSteps, (num, key)=>{
          const value = num * minuteStep;
          const minute = value < 10 ? '0' + value : value;
          return <option value={minute} key={num}>{minute}</option>
        })}
      </select>
    )
  }

  render() {
    const {
      ampm,
    } = this.state;

    return (
      <div className='timepicker-2'>
        <div className='timepicker-2-fields'>
          <div className='form-group hour'>
            {this.renderHours()}
          </div>
          <div className='form-group minute'>
            {this.renderMinutes()}
          </div>
          <div className='form-group am-pm'>
            <select value={ampm} onChange={this.onChange('ampm')} className='form-control'>
              <option></option>
              <option value='am' key={1}>AM</option>
              <option value='pm' key={2}>PM</option>
            </select>
          </div>
        </div>
      </div>
    )
  }
}



export default TimePicker2;



// WEBPACK FOOTER //
// ./src/components/Form/Fields/TimePicker2/index.js